import { GET_PARTNERS } from '../actions.type'
import { SET_PARTNERS } from '../mutations.type'
import PartnerService from '@/services/PartnerService'

const state = {
  partners: [],
  partnerData: {}
}

const getters = {
  partners: state => state.partners.map(id => state.partnerData[id])
}

const actions = {
  [GET_PARTNERS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      PartnerService.getPartners()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_PARTNERS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_PARTNERS]: (state, data) => {
    const partnerData = {}
    data.forEach(partner => {
      partnerData[partner.id] = partner
    });
    state.partnerData = Object.assign({}, partnerData)
    state.partners = Object.keys(partnerData)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
